import * as types from '../mutation-types'
import * as consts from '../../../modules/data/base/consts'
import { UTILS_UNI } from '../../../modules/utils'

export default {
    namespaced: true,
    state: {
        initSharePicResource: false,
		sharePicAvatarImg: '',
		sharePicImageList: [],
    },
    mutations: {},
    actions: {
		downLoadSharePicResources({ dispatch, state }, params) {
			// console.error('downSharePicResources', state, params)
			// 已经加载过了就不用再加载了
			if(state.initSharePicResource) {
				if(params && params.cb && typeof(params.cb) == 'function') {
					params.cb();
				}
				return;
			}
			// 排队冒泡加载页面所需要的资源
			var baseUrl = 'http://m1.2048.net/duoniu/images/';
			var avatarImg = [params.userInfo.avatar];
			var shareType = params.type, scoreArr = params.scoreArr, shareImgList = [];
			// 处理图片
			shareImgList.push(baseUrl+'index/index-bg.png');
			shareImgList.push(baseUrl+'share/share-bg-'+shareType+'.png');
			shareImgList.push(baseUrl+'cow/cow-t-'+shareType+'.png');
			shareImgList.push(baseUrl+'cow/cow-'+shareType+'.png');
			shareImgList.push(baseUrl+'share/share-pbg-'+shareType+'.png');
			shareImgList.push(baseUrl+'cow/cow-sbg-'+shareType+'.png');
			shareImgList.push(baseUrl+'common/num-'+scoreArr[0]+'.png');
			shareImgList.push(baseUrl+'common/num-'+scoreArr[1]+'.png');
			shareImgList.push(baseUrl+'share/share-cbg.png');
			shareImgList.push(baseUrl+'share/share-title.png');
			shareImgList.push(baseUrl+'share/code.png');
			// console.error('avatarImage-------', shareType, avatarImg, shareImgList)
			UTILS_UNI.downLoadFilesListInTemp(avatarImg, function(ret) {
				state.sharePicAvatarImg = ret[0]; 
				UTILS_UNI.downLoadFilesListInTemp(shareImgList, function(ret) {
					state.sharePicImageList = ret;
					state.initSharePicResource = true;
					console.log('downSharePicResources成功:::::::', state.sharePicAvatarImg, state.sharePicImageList)
					// 成功后执行回调
					if(params && params.cb && typeof(params.cb) == 'function') {
						params.cb();
					}
				}, function() {
					dispatch('downSharePicResources', params);
				});
			}, function() {
				dispatch('downSharePicResources', params);
			});
		},
		
    }
}